import querystring from "query-string";
export const useWindowSearchQuery = () => querystring.parse(window.location.search);
//# sourceMappingURL=useWindowSearchQuery.js.map